import './styles.scss';
import React from 'react';

interface Props {
    title:any,
    subtitle?:string,
}

function FormLabel({ title, subtitle }:Props) {
    return (
        <div className='form-header'>
            <div className='form-header-title'>
                {title}
            </div>
            <div className='form-header-subtitle'>
                {subtitle}
            </div>
        </div>
    )
}

export default FormLabel;